"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collapseNodes_1 = require("../utils/collapseNodes");
var contains_1 = require("../utils/contains");
var createRange_1 = require("../selection/createRange");
var getTagOfNode_1 = require("../utils/getTagOfNode");
var isBlockElement_1 = require("../utils/isBlockElement");
var isNodeAfter_1 = require("../utils/isNodeAfter");
var wrap_1 = require("../utils/wrap");
var splitParentNode_1 = require("../utils/splitParentNode");
var STRUCTURE_NODE_TAGS = ['TD', 'TH', 'LI', 'BLOCKQUOTE'];
/**
 * This reprents a block that is identified by a start and end node
 * This is for cases like &lt;root&gt;Hello&lt;BR&gt;World&lt;/root&gt;
 * in that case, Hello&lt;BR&gt; is a block, World is another block
 * Such block cannot be represented by a NodeBlockElement since they don't chained up
 * to a single parent node, instead they have a start and end
 * This start and end must be in same sibling level and have same parent in DOM tree
 */
var StartEndBlockElement = /** @class */ (function () {
    function StartEndBlockElement(rootNode, startNode, endNode) {
        this.rootNode = rootNode;
        this.startNode = startNode;
        this.endNode = endNode;
    }
    StartEndBlockElement.getBlockContext = function (node) {
        while (node && !isBlockElement_1.default(node)) {
            node = node.parentNode;
        }
        return node;
    };
    /**
     * Collapse this element to a single DOM element.
     * If the content nodes are separated in different root nodes, wrap them to a single node
     * If the content nodes are included in root node with other nodes, split root node
     */
    StartEndBlockElement.prototype.collapseToSingleElement = function () {
        var nodes = collapseNodes_1.default(StartEndBlockElement.getBlockContext(this.startNode), this.startNode, this.endNode, true /*canSplitParent*/);
        var blockContext = StartEndBlockElement.getBlockContext(this.startNode);
        while (nodes[0] &&
            nodes[0] != blockContext &&
            nodes[0].parentNode != this.rootNode &&
            STRUCTURE_NODE_TAGS.indexOf(getTagOfNode_1.default(nodes[0].parentNode)) < 0) {
            nodes = [splitParentNode_1.splitBalancedNodeRange(nodes)];
        }
        return nodes.length == 1 && isBlockElement_1.default(nodes[0])
            ? nodes[0]
            : wrap_1.default(nodes);
    };
    /**
     * Gets the start node
     */
    StartEndBlockElement.prototype.getStartNode = function () {
        return this.startNode;
    };
    /**
     * Gets the end node
     */
    StartEndBlockElement.prototype.getEndNode = function () {
        return this.endNode;
    };
    /**
     * Checks equals of two blocks
     */
    StartEndBlockElement.prototype.equals = function (blockElement) {
        return (this.startNode == blockElement.getStartNode() &&
            this.endNode == blockElement.getEndNode());
    };
    /**
     * Checks if another block is after this current
     */
    StartEndBlockElement.prototype.isAfter = function (blockElement) {
        return isNodeAfter_1.default(this.getStartNode(), blockElement.getEndNode());
    };
    /**
     * Checks if an Html node is contained within the block
     */
    StartEndBlockElement.prototype.contains = function (node) {
        return (contains_1.default(this.startNode, node, true /*treatSameNodeAsContain*/) ||
            contains_1.default(this.endNode, node, true /*treatSameNodeAsContain*/) ||
            (isNodeAfter_1.default(node, this.startNode) && isNodeAfter_1.default(this.endNode, node)));
    };
    /**
     * Get the text content of this block element
     */
    StartEndBlockElement.prototype.getTextContent = function () {
        var range = createRange_1.default(this.getStartNode(), this.getEndNode());
        return range ? range.toString() : '';
    };
    return StartEndBlockElement;
}());
exports.default = StartEndBlockElement;
//# sourceMappingURL=StartEndBlockElement.js.map